var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-356 -861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_placeholder",
    "data-name": "Icon placeholder",
    transform: "translate(356 864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box",
    transform: "translate(0 -2.689)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27882",
    "data-name": "Rectangle 27882",
    width: 16,
    height: 19,
    transform: "translate(0 -0.311)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_Edit_16x16",
    "data-name": "Icon Edit 16x16",
    transform: "translate(356 863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box-2",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28195",
    "data-name": "Rectangle 28195",
    width: 16,
    height: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Paths",
    transform: "translate(1.334 1.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_339957",
    "data-name": "Path 339957",
    d: "M15.128,8.922l-2.7-2.732a.633.633,0,0,0-.933,0l-8.63,8.63a.666.666,0,0,0-.2.466L2,18.651a.666.666,0,0,0,.666.666l3.365-.666a.666.666,0,0,0,.466-.2l8.63-8.6a.633.633,0,0,0,0-.933Zm-9.363,8.4-2.432.666L4,15.553l6.164-6.131L11.9,11.188Zm7.1-7.064L11.1,8.489l.866-.9,1.766,1.8Z",
    transform: "translate(-2 -5.985)",
    fill: "#09828b"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.80684f9f8cf61b584e06747a83d4e3d3.svg";
export { ForwardRef as ReactComponent };